import styles from '../../assets/styles/Transactions/Transactions.module.scss';
import { MimaText, PageLoader, MimaButton } from '../../components';
import { downloadXlsx2 } from '../../utils/download';
import constant from '../../utils/constant';
import Expenses from './Expenses';
import Income from './Income';
import moment from 'moment';
import React from 'react';

const RecentTransactions = ({
	allIncomeTable,
	allExpensesTable,
	incomeTable,
	loading,
	expenseTable,
	refresh,
	transactions,
	filteredTransactions,
	setFilteredTransactions,
	setViewMoreExpense,
	setOpenTagModal,
	setViewMoreIncome,
}) => {
	const printData = filteredTransactions.map(transaction => ({
		Date: moment(transaction.createdAt).format('DD-MM-YYYY hh:mm'),
		Type: transaction.type,
		Customer: transaction.customer ? transaction.customer.fullname : '',
		Amount:
			transaction.type === constant.TRANSACTION_TYPE.EXPENSE
				? `-${transaction.transactionAmount}`
				: transaction.transactionAmount || 0,
		Bank: transaction.bankName || '',
		currencyCode: transaction.currencyCode,
		category: transaction.category,
		walletBalance: transaction.walletBalance,
		AccountNumber:
			transaction.type === constant.TRANSACTION_TYPE.EXPENSE
				? transaction.receiverAccountNumber || ''
				: transaction.sourceAccountNumber || '',
		AccountName:
			transaction.type === constant.TRANSACTION_TYPE.EXPENSE
				? transaction.receiverAccountName || ''
				: transaction.sourceAccountName || '',
		Deposit:
			transaction.type === constant.TRANSACTION_TYPE.EXPENSE
				? `-${transaction.deposit}`
				: transaction.deposit || 0,
		ExpenseCategory: transaction.expenseCategory
			? transaction.expenseCategory.name
			: '',
		Narration: transaction.narration || '',

		Balance: transaction.balanceAmount,
		Status: transaction.status,
		'Paid Date': moment(transaction.paidDate).format('DD-MM-YYYY hh:mm'),
		'Due Date': moment(transaction.dueDate).format('DD-MM-YYYY hh:mm'),
		'Balance Due Date': moment(transaction.balanceDueDate).format(
			'DD-MM-YYYY hh:mm'
		),
	}));

	return (
		<div className={styles.recent}>
			<MimaText mt={4} variant="bodyBold" align="center">
				You are viewing{' '}
				{incomeTable ? 'Inflow' :  'Outflow' }{' '}
				Transactions{' '}
			</MimaText>

			<div className={styles.main_nav}>
				<div
					className={
						incomeTable ? styles.main_nav_item_active : styles.main_nav_item
					}
					onClick={allIncomeTable}>
					Inflow
				</div>
				<div
					className={
						expenseTable ? styles.main_nav_item_active : styles.main_nav_item
					}
					onClick={allExpensesTable}>
					Outflow
				</div>
				<div
					className={styles.main_nav_item}
					onClick={() => {
						downloadXlsx2(printData, `Transactions`);
					}}>
					Download Report
				</div>
			</div>

			{loading ? (
				<PageLoader title="While we set things up for you" loading={loading} />
			) : (
				<>
					<MimaButton
						variant="filter"
						title="Refresh"
						onClick={refresh}
						width={10}
						mt={2}
					/>
					{incomeTable && (
						<Income
							transactions={transactions}
							setFilteredTransactions={setFilteredTransactions}
							filteredTransactions={filteredTransactions}
							setOpenTagModal={setOpenTagModal}
							setViewMoreIncome={setViewMoreIncome}
						/>
					)}
					{expenseTable && (
						<Expenses
							transactions={transactions}
							filteredTransactions={filteredTransactions}
							setFilteredTransactions={setFilteredTransactions}
							setViewMoreExpense={setViewMoreExpense}
						/>
					)}
				</>
			)}
		</div>
	);
};

export default RecentTransactions;
